/**
 * Problem registry for Quadratic Gallery (二次函数图鉴): every收录题 in
 * display order. The sidebar tab bar and the QA hook both read this list.
 */

import { sh2021q24 } from "./sh2021q24";
import { sh2023q24 } from "./sh2023q24";
import { sh2025q24 } from "./sh2025q24";
import { sh2026q23 } from "./sh2026q23";
import type { ProblemDef } from "./types";

/** All quad-gallery problems, in tab order. */
export const PROBLEMS: readonly ProblemDef[] = [sh2021q24, sh2023q24, sh2025q24, sh2026q23];

/** Look up a problem by id; undefined when absent. */
export function problemById(id: string): ProblemDef | undefined {
  return PROBLEMS.find((p) => p.id === id);
}
